export const OPEN_SIDE_MENU = "OPEN_SIDE_MENU";
export const CONTENT_LOADING = "CONTENT_LOADING";
export const SET_SIDE = "SET_SIDE";
